//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue              from 'vue';
import Component        from 'vue-class-component';
import Footer           from '@/components/Footer';
import NavBar           from '@/components/NavBar';
import TransitionHeight from '@/components/TransitionHeight';

@Component({
	metaInfo   : {
		title         : 'Tropical Tower Wars',
		titleTemplate : 'TTW | %s',
	},
	components : {
		Footer,
		NavBar,
		TransitionHeight,
	},
})
export default class App extends Vue {
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<div id="app">
	<transition name="t--fade" mode="out-in">
		<router-view />
	</transition>

	<NavBar :offset="$route.path === '/'" />

	<Footer />
</div>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss">
#app {
	position                    : relative;
	max-width                   : 100vw;
}

@import './assets/scss/default.scss';
@import './assets/scss/general.scss';
@import './assets/scss/snippet.scss';
@import './assets/scss/responsive.scss';
@import './assets/scss/transitions.scss';
</style>
